import { render, staticRenderFns } from "./weier_assemble_label.vue?vue&type=template&id=3e9c2ed5&scoped=true&"
import script from "./weier_assemble_label.vue?vue&type=script&lang=js&"
export * from "./weier_assemble_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9c2ed5",
  null
  
)

export default component.exports